/**
 * <custom-option-set> -- combination-driven product image swap (Impact theme)
 * ---------------------------------------------------------------------------
 * Three NON-VARIANT options (metal finish, paint colour, foot-end height),
 * rendered by snippets/custom-option-set.liquid as native radio inputs +
 * .block-swatch / .color-swatch labels (so they look identical to the theme's
 * variant pickers, and the checked radio submits its line-item property).
 *
 * This script does ONE thing: when a selection changes, it rebuilds the
 * composite key  finish|color|footend , looks up the mapped product media id,
 * and swaps the gallery to it via the theme's OWN <media-carousel>.select()
 * (the same call the theme makes on a native variant change, so thumbnails,
 * dots and zoom stay in sync).
 *
 * Selected/hover/focus styling is handled entirely by the theme's CSS via
 * input:checked -- there is no class juggling here. It never listens to
 * variant:change and never touches price, SKU, inventory or the Size option.
 * All lookup data is inlined by Liquid, so the swap is instant and fetch-free.
 */
(function () {
  if (window.customElements && window.customElements.get('custom-option-set')) return;

  var OPTIONS = ['finish', 'color', 'footend'];

  class CustomOptionSet extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      // Parse the inlined key -> media id map (minimal payload).
      this._images = {};
      var json = this.querySelector('.custom-option-set__images');
      if (json) {
        try { this._images = JSON.parse(json.textContent || '{}'); } catch (e) { this._images = {}; }
      }

      this._formId = this.getAttribute('data-form') || '';
      this._defaultMedia = this.getAttribute('data-default-media') || '';
      this._lastMedia = null;

      // One delegated listener for the whole component.
      this.addEventListener('change', this._onChange.bind(this));
    }

    _onChange(event) {
      var input = event.target;
      if (!input || input.type !== 'radio' || !input.hasAttribute('data-option')) return;

      // Keep the "Label: <value>" heading in sync with the chosen value.
      var group = input.closest('[data-option-group]');
      if (group) {
        var labelEl = group.querySelector('[data-selected-label]');
        if (labelEl) labelEl.textContent = input.getAttribute('data-label') || input.value;
      }

      this._swap();
    }

    _currentKey() {
      return OPTIONS.map(function (opt) {
        var checked = this.querySelector('input[data-option="' + opt + '"]:checked');
        return (checked ? checked.getAttribute('data-value') : '').toLowerCase();
      }, this).join('|');
    }

    _swap() {
      var key = this._currentKey();

      // Look it up; fall back to the configured default media so a data gap never blanks the image.
      var mediaId = this._images[key];
      if (mediaId === undefined || mediaId === null) mediaId = this._defaultMedia;
      if (!mediaId) return;
      if (String(mediaId) === String(this._lastMedia)) return; // already showing it
      this._lastMedia = mediaId;

      var gallery =
        (this._formId && document.querySelector('product-gallery[form="' + this._formId + '"]')) ||
        document.querySelector('product-gallery');
      if (!gallery) return;

      var target = gallery.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
      if (!target) return;

      // The media might have been hidden by the theme's variant image-set filtering.
      if (target.hasAttribute('hidden')) target.removeAttribute('hidden');

      // Preferred path: drive the theme's native carousel (also syncs thumbnails + dots + zoom).
      // This changes the shown image IN PLACE, without moving the page.
      var carousel = target.closest('media-carousel');
      var handled = false;
      if (carousel && typeof carousel.select === 'function' && carousel.items) {
        var index = carousel.items.indexOf(target);
        if (index > -1) {
          carousel.select(index, { animate: true });
          handled = true;
        }
      }

      // Fallback for non-carousel (grid) layouts: bring the media on screen. Skipped on mobile, where the
      // gallery sits ABOVE the options, so scrollIntoView would jump the page up on every selection.
      var isMobile = window.matchMedia('(max-width: 741px)').matches;
      if (!handled && !isMobile) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  }

  window.customElements.define('custom-option-set', CustomOptionSet);
})();
